<div class="dialog-container">
    <h2 mat-dialog-title>Artikel vergleichen</h2>

    <mat-dialog-content>
        <form [formGroup]="compareForm">
            <mat-form-field
                appearance="outline"
                class="field-quarter">
                <mat-label>OrganisationSiteKey</mat-label>
                <input
                    matInput
                    formControlName="organizationSiteKey" />
                @if (
                    compareForm
                        .get('organizationSiteKey')
                        ?.hasError('required') &&
                    compareForm.get('organizationSiteKey')?.touched
                ) {
                    <mat-error> OrganisationSiteKey wird benötigt </mat-error>
                }
            </mat-form-field>
            <div formArrayName="articles">
                @for (
                    articleGroup of articlesArray.controls;
                    let i = $index;
                    track articleGroup
                ) {
                    <div
                        [formGroupName]="i"
                        class="article-section">
                        <div class="article-header">
                            <h3>Artikel {{ i + 1 }}</h3>
                            @if (articlesArray.length > 1) {
                                <button
                                    type="button"
                                    mat-icon-button
                                    (click)="removeArticle(i)"
                                    class="remove-button">
                                    <mat-icon
                                        fontSet="material-symbols-outlined"
                                        >close</mat-icon
                                    >
                                </button>
                            }
                        </div>

                        <div class="article-fields">
                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label
                                    [matTooltip]="
                                        'Bestellnummer / articleOrderNumber'
                                    ">
                                    PO Nummer
                                </mat-label>
                                <input
                                    matInput
                                    formControlName="articleOrderNumber" />
                                @if (
                                    articleGroup
                                        .get('articleOrderNumber')
                                        ?.hasError('required') &&
                                    articleGroup.get('articleOrderNumber')
                                        ?.touched
                                ) {
                                    <mat-error>
                                        PO Nummer wird benötigt
                                    </mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label
                                    [matTooltip]="
                                        'item code / consigneeOrderNumber'
                                    ">
                                    Artikel-Nr. Empfänger
                                </mat-label>
                                <input
                                    matInput
                                    formControlName="consigneeOrderNumber" />
                                @if (
                                    articleGroup
                                        .get('consigneeOrderNumber')
                                        ?.hasError('required') &&
                                    articleGroup.get('consigneeOrderNumber')
                                        ?.touched
                                ) {
                                    <mat-error>
                                        Artikel-Nr. Empfänger wird benötigt
                                    </mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                class="field-quarter">
                                <mat-label>Menge</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    min="0"
                                    formControlName="quantity"
                                    placeholder="1" />
                                @if (
                                    articleGroup
                                        .get('quantity')
                                        ?.hasError('required') &&
                                    articleGroup.get('quantity')?.touched
                                ) {
                                    <mat-error>Menge wird benötigt</mat-error>
                                }
                                @if (
                                    compareForm
                                        .get('articles')
                                        ?.get('' + i)
                                        ?.get('quantity')
                                        ?.hasError('min') &&
                                    compareForm
                                        .get('articles')
                                        ?.get('' + i)
                                        ?.get('quantity')?.touched
                                ) {
                                    <mat-error
                                        >Menge muss mindestens 0 sein</mat-error
                                    >
                                }
                            </mat-form-field>
                        </div>
                    </div>
                }
            </div>

            <button
                type="button"
                mat-stroked-button
                (click)="addArticle()"
                class="add-article-button">
                <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
                Weiterer Artikel
            </button>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button
            mat-stroked-button
            (click)="closeWithResult('cancel')">
            Abbrechen
        </button>
        <button
            mat-flat-button
            color="primary"
            (click)="onSubmit()">
            Vergleich starten
        </button>
    </mat-dialog-actions>
</div>
